// us states options
export const stateOptions = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
];

// interset qualification options
export const specialInterestQualifications = [
  {
    value: "LGBTQ co-founder(s)",
    label: "LGBTQ co-founder(s)",
    id: "lgbtq-co-founders",
  },
  {
    value: "People of color co-founder(s)",
    label: "People of color co-founder(s)",
    id: "people-of-color-co-founders",
  },
  {
    value: "Veteran co-founder(s)",
    label: "Veteran co-founder(s)",
    id: "veteran-co-founders",
  },
  {
    value: "Women co-founder(s)",
    label: "Women co-founder(s)",
    id: "women-co-founders",
  },
  {
    value: "Impact investment",
    label: "Impact investment",
    id: "impact-investment",
  },
];

// security type options
export const securityTypes = [
  { value: "Priced round", label: "Priced round", id: "priced-round" },
  {
    value: "Convertible note",
    label: "Convertible note",
    id: "convertible-note",
  },
  { value: "SAFE", label: "SAFE", id: "safe" },
  { value: "Other", label: "Other", id: "other" },
];

// committed options
export const committedPercentage = [
  {
    value: "Over subscribing (100%)",
    label: "Over subscribing (100%)",
    id: "over-subscribing-100",
  },
  { value: "At least (75%)", label: "At least (75%)", id: "atleast-75" },
  { value: "At least (50%)", label: "At least (50%)", id: "atleast-50" },
  { value: "Less than half", label: "Less than half", id: "less-than-half" },
  { value: "Starting (0%)", label: "Starting (0%)", id: "starting-zero" },
];
